import React from "react";
import ServicePage from "./ServicePage";

export default function DigitalizarePage() {
  return (
    <ServicePage
      number="02"
      eyebrow="Serviciu digital"
      title={["Digitalizare."]}
      tagline="Soluții complete de digitalizare pentru companii — optimizare completă în IT&C și marketing, cu instruire și consultanță avansată pentru echipamente, rețele și strategii de marketing eficiente."
      intro={[
        "Digitalizarea cu SUNTEC înseamnă un ecosistem integrat: hardware, software, servicii de marketing și consultanță — livrate de o echipă cu peste 20 de ani de experiență în proiecte industriale și europene.",
      ]}
      bullets={[
        "Arhivare electronică avansată și acces personalizat pentru a moderniza și securiza gestiunea informațiilor.",
        "Comunicare rapidă și clară cu clienți și angajați, cu impact direct în productivitate și vizibilitate.",
      ]}
      programs={["Start-up Nation", "Femeia Antreprenor", "Digitalizare IMM", "Alte proiecte europene"]}
      stepsEyebrow="Metodologia SUNTEC"
      stepsTitle="Trei pași, un rezultat măsurabil."
      steps={[
        {
          title: "Consultanță",
          desc: "Analizăm nevoile companiei și propunem soluții adaptate fiecărei situații identificate.",
        },
        {
          title: "Planificare",
          desc: "Supraveghem și coordonăm fiecare fază a realizării proiectului de digitalizare.",
        },
        {
          title: "Implementare",
          desc: "Echipele noastre cu peste 20 de ani de experiență se ocupă de punerea în practică a soluțiilor.",
        },
      ]}
      servicesEyebrow="Servicii incluse"
      servicesTitle="Un pachet cu opt direcții tehnice."
      services={[
        {
          title: "Echipamente ITC & more",
          tags: "Calculatoare · laptopuri · servere · infrastructură rețea · stații grafice · imprimante · tablete.",
          desc: "O multitudine de echipamente hardware TIC și dispozitive mobile asigură baza necesară pentru digitalizarea unei afaceri — cu creștere de eficiență, securitate și productivitate și un avantaj clar pe piață.",
        },
        {
          title: "Software & licențe",
          tags: "Sisteme de operare · aplicații business · securitate · cloud · IoT · CRM · ERP · HCM · WMS · EDI · SFA.",
          desc: "Software-ul de ultimă oră și serviciile de licențiere sunt esențiale pentru optimizarea și automatizarea proceselor de business. Integrarea sistemică facilitează o digitalizare vitală pentru evoluția companiilor.",
        },
        {
          title: "Publicitate online & offline",
          tags: "Campanii digitale · reclame tipărite · panouri · pliante · broșuri · media mix.",
          desc: "Campaniile integrate combină digital cu tradițional pentru a construi brandul, a atrage și a menține clienți. În era digitală, o abordare integrală a marketingului nu este opțională.",
        },
        {
          title: "Website & Webshop",
          tags: "Design web · dezvoltare e-commerce · SEO · administrare conținut · analiză trafic · optimizare conversii.",
          desc: "Site-urile web și platformele e-commerce sunt fundamentale în transformarea vizitatorilor în clienți și în maximizarea profiturilor afacerii.",
        },
        {
          title: "Strategie & plan de marketing",
          tags: "Cercetare de piață · branding · poziționare · planificare campanie · analiză performanță · marketing mix.",
          desc: "Planul de marketing conturează strategia de promovare — de la evaluarea situației și piaței, la pașii operaționali pentru atingerea obiectivelor. Un plan structurat asigură inițiative aliniate și adaptabile la o piață în schimbare.",
        },
        {
          title: "Manual de brand",
          tags: "Identitate vizuală · ghid stil · logo · norme utilizare · paletă cromatică · fonturi · coerență de brand.",
          desc: "Manualul de brand cuprinde regulile care asigură coerența și unitatea mesajului în toate formele de comunicare — vizuală, text sau audio. Este esențial pentru o reputație puternică pe termen lung.",
        },
        {
          title: "Conținut foto, video & text",
          tags: "Fotografii · producție video · copywriting · storytelling · redactare editorială · spoturi audio · articole PR · blog · social media.",
          desc: "Conținutul vizual și textul de calitate comunică valorile companiei. Publicul poate fi informat, captivat sau inspirat — se construiește o legătură emoțională puternică între brand și clienți.",
        },
        {
          title: "Consultanță & instruire",
          tags: "Selectare echipamente · configurare software · gestionare infrastructură rețea · optimizare stații grafice.",
          desc: "Selectăm hardware-ul necesar, configurăm software-ul și asigurăm gestionarea rețelei. Oferim îndrumare în utilizarea eficientă a echipamentelor IT pentru funcționare optimă și productivitate crescută.",
        },
      ]}
    />
  );
}
